import {fields} from "./config";
import {Button, Col, Form, Popover, Row, Space, Table} from "antd";

import {CreateReceiptSVG, ExcelSVG, ListIconSVG, PlusWhiteSVG} from "assets";
import {ButtonExcel, ExpandSearch, ModalCustom} from "components/common";
import React, {useEffect, useRef, useState} from "react";
import {columnsTable} from "./config";
import ColumnPopoverDisplay from "components/common/PopoverTable/PopoverTable";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {getListPhongAPI, setActiveKey} from "redux/reducer/common";
import {FORMAT_TIME, LOAI_FORM, tabKeys} from "types/enums";
import {glassKiotService} from "api";
import {ColumnProps} from "types/models";
import Notification from "components/common/notification/notification";
import {TableRowSelection} from "antd/es/table/interface";
import {
  setDetailBill,
  setIdBill,
  setTypePrescription,
} from "redux/reducer/glassKiot";
import {
  exportFile,
  formatDateToString,
  getTableOptions,
  renderSTT,
  saveTableOptions,
} from "helper/common";
import dayjs from "dayjs";
import moment from "moment";
import ExportModal from "../ExportModal/ExportModal";
import {LOAI_DON_KINH, TT_DON_KINH} from "types/enums/glass";
import KCBStatusColumn from "components/common/ColumnColors/KCBTypeColumn/KCBStatusColumn";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
const List2 = () => {
  let savedTableOption = getTableOptions(
    "GLASS_LIST2_TABLE",
    localStorage.getItem("username")
  );
  columnsTable.find(e => e.dataIndex == "stt").render = (v, r, i) => {
    return <>{renderSTT(i, currentPage, limit)}</>;
  };
  const defaultColumns = savedTableOption
    ? columnsTable.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columnsTable;
  const [form] = Form.useForm();
  const expandRef = useRef(null);
  const reportRef = useRef<any>();
  const exportRef = useRef<any>(null);
  const [columns, setColumns] = useState(
    defaultColumns.filter(e => e.show === true)
  );
  const listStore = useAppSelector(state => state.glassStore.listStore);
  const idBill = useAppSelector(state => state.glassKiot.idBill);
  //setup để lấy data ,xử lý loading,chuyển trang
  const listPhong = useAppSelector(state => state.common.listPhong);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState();
  const [data, setData] = useState(null);
  const searchForm = useAppSelector(state => state.glassKiot.searchForm);
  const activeTabPresciption = useAppSelector(
    state => state.glassKiot.activeTabPresciption
  );
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    status: TT_DON_KINH.DA_BAN,
    end: formatDateToString(moment(), FORMAT_TIME.dayFull),
    start: formatDateToString(moment(), FORMAT_TIME.dayFull),
  });
  const activeTab = useAppSelector(state => state.common.activeTab);
  const dispatch = useAppDispatch();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const listTTKCB = useAppSelector(state => state.common.listTTKCB);
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
    saveTableOptions(
      "GLASS_LIST2_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
  };
  useEffect(() => {
    if (activeTabPresciption == tabKeys.GLASSES.LIST_2) {
      setParams({...params, ...searchForm});
      setCurrentPage(1);
    }
  }, [searchForm]);
  useEffect(() => {
    if (activeTabPresciption == tabKeys.GLASSES.LIST_2) {
      getListBill(params);
    }
  }, [activeTab, params]);
  useEffect(() => {
    dispatch(getListPhongAPI());
  }, []);
  useEffect(() => {
    const renderPhong = () => {
      columns.find(e => e?.dataIndex == "phong").render = (v, r, i) => {
        const tenPhong = listPhong.find(phong => phong?.id == v)?.tenPhong;
        return <>{tenPhong}</>;
      };
    };
    renderPhong();
  }, [listPhong]);

  useEffect(() => {
    const renderStore = () => {
      columns.find(e => e?.dataIndex == "storeId").render = (v, r, i) => {
        const tenStore = listStore.find(store => store?.id == v)?.name;
        return <>{tenStore}</>;
      };
    };
    renderStore();
  }, [listStore]);

  const handlePaginationChange = (page, limit) => {
    setCurrentPage(page);
    setLimit(limit);
    setParams({...params, page: page, limit: limit});
  };
  const paginationConfig = {
    current: currentPage,
    total: total,
    onChange: handlePaginationChange,
  };
  // useEffect(() => {
  //   expandRef?.current.setFieldValue("end", dayjs());
  //   expandRef?.current.setFieldValue("start", dayjs());
  // }, []);
  useEffect(() => {
    getListBill(params);
  }, [params]);
  const getListBill = async params => {
    try {
      setLoading(true);
      const res = await glassKiotService.getListBill(params);
      const data = res.data.map(e => ({...e, key: e.id}));
      setData(data);
      setTotal(res.total);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi lấy danh sách đơn");
    }
  };
  const onSelectChange = (
    selectedRowKeys: React.Key[],
    selectedRows: any[]
  ) => {
    setSelectedRowKeys([selectedRowKeys[selectedRowKeys.length - 1]]);

    if (selectedRows.length == 0) {
      dispatch(setIdBill(null));
      dispatch(setDetailBill(null));
    } else {
      dispatch(setIdBill(selectedRows[selectedRows.length - 1]?.id));
    }
  };
  const navigateTab = () => {
    dispatch(setActiveKey(tabKeys.GLASSES.TAB_2));
  };
  const createBill = () => {
    navigateTab();
    dispatch(setTypePrescription(LOAI_DON_KINH.TAO_MOI));
    if (selectedRowKeys.length == 0) {
      dispatch(setIdBill(null));
      dispatch(setDetailBill(null));
    }
  };
  const viewDetail = () => {
    if (idBill != null) {
      navigateTab();
      dispatch(setTypePrescription(LOAI_DON_KINH.DA_TAO));
    } else {
      Notification("warning", "Chưa chọn đơn");
    }
  };
  const rowRadio: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
    hideSelectAll: true,
    selections: [Table.SELECTION_NONE],
  };
  const onClickSearchButton = () => {
    var searchFields = expandRef?.current?.getData();
    setParams({
      ...params,
      ...searchFields,
      ngaySinh: formatDateToString(searchFields?.ngaySinh, FORMAT_TIME.dayFull),
      start: formatDateToString(searchFields?.start, FORMAT_TIME.dayFull),
      end: formatDateToString(searchFields?.end, FORMAT_TIME.dayFull),
      ngayBanTu: formatDateToString(
        searchFields?.ngayBanTu,
        FORMAT_TIME.dayFull
      ),
      ngayBanDen: formatDateToString(
        searchFields?.ngayBanDen,
        FORMAT_TIME.dayFull
      ),
      page: 1,
    });
    setCurrentPage(1);
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearchButton();
    }
  };
  const getReportFileByBillExcel = async () => {
    const data = {
      start: params?.ngayBanTu,
      end: params?.ngayBanDen,
      // status: params?.status,
      khoId: params?.storeId,
    };

    if (!data.start) {
      Notification("warning", "Chưa chọn ngày bán từ");
    } else if (!data.end) {
      Notification("warning", "Chưa chọn ngày bán đến");
    } else {
      try {
        exportFile(
          "store/glasses-sales/export-thong-ke-don-ban",
          data,
          "Báo cáo doanh thu kính theo đơn"
        );
        // const res = await glassKiotService.getReportFileByBillExcelStore(data);
        //
      } catch (error) {}
    }
  };
  const getReportFileByBillPdf = async () => {
    const data = {
      start: params?.ngayBanTu,
      end: params?.ngayBanDen,
      // status: params?.status,
      khoId: params?.storeId,
    };

    if (!data.start) {
      Notification("warning", "Chưa chọn ngày bán từ");
    } else if (!data.end) {
      Notification("warning", "Chưa chọn ngày bán đến");
    } else {
      try {
        exportFile(
          "store/glasses-sales/export-thong-ke-don-ban-pdf",
          data,
          "Báo cáo doanh thu kính theo đơn",
          "pdf"
        );
        // const res = await glassKiotService.getReportFileByBillExcelStore(data);
        //
      } catch (error) {}
    }
  };
  useEffect(() => {
    renderTTKCB();
  }, [listTTKCB]);
  const renderTTKCB = () => {
    columns.find(e => e.dataIndex == "trangThaiKCB").render = (v, r, i) => {
      let textKCB = listTTKCB.find(e => e.id == v)?.tenTTPhieuKham;
      return <KCBStatusColumn label={textKCB}></KCBStatusColumn>;
    };
  };
  const getReportFileByItemExcel = async () => {
    const data = {
      start: params?.ngayBanTu,
      end: params?.ngayBanDen,
      loaiItem: "KI",
      // status: params?.status,
      khoId: params?.storeId,
    };
    if (data?.khoId == null) {
      Notification("warning", "Chưa chọn kho");
    } else if (!data?.start) {
      Notification("warning", "Chưa chọn ngày bán từ");
    } else if (!data?.end) {
      Notification("warning", "Chưa chọn ngày bán đến");
    } else {
      let nameFile = `Báo cáo doanh thu theo từng vật tư ${data?.start} - ${data?.end}`;
      // if (data?.status == TT_DON_KINH.HOAN_LAI) {
      //   nameFile = `Báo cáo hoàn trả theo mã hàng hóa ${data?.start} - ${data?.end}`;
      // } else {
      //   nameFile = `Báo cáo doanh thu theo từng vật tư ${data?.start} - ${data?.end}`;
      // }

      exportFile("store/tckt/export-doanh-thu-theo-item", data, nameFile);
    }
  };
  const getReportFileByItemPdf = async () => {
    const data = {
      start: params?.ngayBanTu,
      end: params?.ngayBanDen,
      loaiItem: "KI",
      // status: params?.status,
      khoId: params?.storeId,
    };
    if (data?.khoId == null) {
      Notification("warning", "Chưa chọn kho");
    } else if (!data?.start) {
      Notification("warning", "Chưa chọn ngày bán từ");
    } else if (!data?.end) {
      Notification("warning", "Chưa chọn ngày bán đến");
    } else {
      let nameFile = `Báo cáo doanh thu theo từng vật tư ${data?.start} - ${data?.end}`;
      // if (data?.status == TT_DON_KINH.HOAN_LAI) {
      //   nameFile = `Báo cáo hoàn trả theo mã hàng hóa ${data?.start} - ${data?.end}`;
      // } else {
      //   nameFile = `Báo cáo doanh thu theo từng vật tư ${data?.start} - ${data?.end}`;
      // }

      exportFile(
        "store/tckt/export-doanh-thu-theo-item-pdf",
        data,
        nameFile,
        "pdf"
      );
    }
  };
  return (
    <div className="glass-bills-list" onKeyDown={onKeyDown} tabIndex={0}>
      <Form form={form} labelAlign="left">
        {/* <div className="container">
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={fields}
            onReset={onClickSearchButton}
          ></ExpandSearch>
        </div> */}

        <div className="container">
          <Space style={{width: "100%"}} direction="vertical">
            <Row justify={"end"}>
              <Col>
                <Space>
                  <Button
                    onClick={() => {
                      exportRef.current.openModal();
                    }}
                  >
                    Xuất báo cáo
                  </Button>
                  <Popover
                    trigger="click"
                    placement="topLeft"
                    content={
                      <ColumnPopoverDisplay
                        setShowColumns={setShowColumns}
                        columns={defaultColumns}
                      ></ColumnPopoverDisplay>
                    }
                  >
                    <Button className="btn-sub" icon={<ListIconSVG />}>
                      Cột hiển thị
                    </Button>
                  </Popover>
                  <Button
                    className="btn-sub"
                    icon={<CreateReceiptSVG />}
                    onClick={createBill}
                  >
                    Tạo đơn mới
                  </Button>
                  <Button className="btn-sub" onClick={viewDetail}>
                    Chi tiết đơn kính
                  </Button>
                </Space>
              </Col>
            </Row>
            <CustomResizableTable
              setShowColumns={setShowColumns}
              // className="custom-resize-table-scroll"
              // scroll={{x: 1600}}
              dataSource={data}
              columns={columns}
              bordered
              rowSelection={rowRadio}
              loading={loading}
              pagination={paginationConfig}
              onRow={(record, rowIndex) => {
                return {
                  onDoubleClick: event => {
                    dispatch(setIdBill(record?.id));
                    dispatch(setTypePrescription(LOAI_DON_KINH.DA_TAO));
                    navigateTab();
                  }, // double click row
                };
              }}
            />
          </Space>
        </div>
      </Form>
      <ModalCustom ref={exportRef} width={300} title={`Chọn loại báo cáo xuất`}>
        <ExportModal
          getReportFileByBillPdf={getReportFileByBillPdf}
          getReportFileByBillExcel={getReportFileByBillExcel}
          getReportFileByItemExcel={getReportFileByItemExcel}
          getReportFileByItemPdf={getReportFileByItemPdf}
        ></ExportModal>
      </ModalCustom>
    </div>
  );
};

export default List2;
